(function(module){

module.service('AlertService', ['toastr','AlertServiceProvider', AlertService]);
module.config(['$httpProvider',function($httpProvider){

            function ErrorServiceInterceptor(AlertService,$q)
            {
                    return {
                        responseError: function(response){
                            
                            var errorMessage = new InterflowErrorMessage(response.data);
                            if (errorMessage.isValid){
                                AlertService.error(errorMessage.message);
                            }

                            return  $q.reject(response);
                        }
                    };
            }


            $httpProvider.interceptors.push(['AlertService','$q',ErrorServiceInterceptor]);
}]);

module.provider('AlertServiceProvider', function(){

    this.defaultTimeout = 5000;

    this.config = {
        closeButton: true,
        timeOut: this.defaultTimeout
    }; 

    this.$get = function (){
        return {
            config: this.config,
            defaultTimeout: this.defaultTimeout
        };
    };

});

function InterflowErrorMessage(json){

    this.isValid = json && json.hasOwnProperty("ErrorMessage") && json.ErrorMessage && json.ErrorMessage.length > 0;

    if (this.isValid){
        this.message = json.ErrorMessage;
    }

}

module.run(['AlertService','$document',function(AlertService,$document){
       if (jQuery){
          jQuery(angular.element($document)).ajaxError(function(xhr,req){
              if (req.status != 401){
                    var response = new InterflowErrorMessage(status.responseJSON);
                    if (response.isValid){
                        AlertService.error(response.message);
                    }  
              }
          }); 
      }
}]);

function AlertService(toastr,AlertServiceProvider){
    
    var config = AlertServiceProvider.config;
    var defaultTimeout = AlertServiceProvider.defaultTimeout;

    function _toast(method, message, time){
        config.timeOut = time === 0 ? 0 : (time || defaultTimeout);
        toastr[method](message, config);
    }
    
    function _info(message, time){
        _toast('info', message, time);
    }

    function _error(message, time){
        _toast('error', message, time);
    }

    function _warning(message, time){
        _toast('warning', message, time);
    }

    function _success(message, time){
        _toast('success', message, time);
    }
 
    return {
        info: _info,
        error: _error,
        warning: _warning,
        success: _success
    }
}


    
    
})(angular.module('InterflowErrors',['toastr']));
